(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseaseDialogController', LeadHospitalizationDiseaseDialogController);

    LeadHospitalizationDiseaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadHospitalizationDisease', 'Disease', 'LeadHospitalization'];

    function LeadHospitalizationDiseaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadHospitalizationDisease, Disease, LeadHospitalization) {
        var vm = this;
        vm.leadHospitalizationDisease = entity;
        vm.diseases = Disease.query();
        vm.leadhospitalizations = LeadHospitalization.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadHospitalizationDiseaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadHospitalizationDisease.id !== null) {
                LeadHospitalizationDisease.update(vm.leadHospitalizationDisease, onSaveSuccess, onSaveError);
            } else {
                LeadHospitalizationDisease.save(vm.leadHospitalizationDisease, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
